// sos-call-v2.js — Estado UI del feature SOS/Colibrí en map-v2
// Ver spec: docs/superpowers/specs/2026-04-12-sos-colibri-design.md

const MAX_BANNERS = 5

const state = {
  // Array<callData> máx 5, dedup por _id
  bannerQueue: [],
  overlayOpen: false,
  // lastActiveCallId: PERSISTIDO en localStorage
  lastActiveCallId: null,
  // currentMeeting: objeto VideoSDK (no serializable)
  currentMeeting: null,
  // videoStream / audioStream: MediaStream del reportante
  videoStream: null,
  audioStream: null,
  isMicOn: false,
  isCamOn: false,
  isVideoExpanded: false,
  // nominatimCache: { [callId]: addressString }
  nominatimCache: {},
  // Modo del overlay: 'docked' (sidebar derecho) | 'floating' (ventana libre)
  mode: 'docked',
  // Posición y tamaño en modo floating (persistidos en localStorage)
  floatingPos: { x: 200, y: 100 },
  floatingSize: { w: null, h: null },
}

const getters = {
  getBannerQueue: (s) => s.bannerQueue,
  isOverlayOpen: (s) => s.overlayOpen,
  getCurrentMeeting: (s) => s.currentMeeting,
  getVideoStream: (s) => s.videoStream,
  getAudioStream: (s) => s.audioStream,
  getIsMicOn: (s) => s.isMicOn,
  getIsCamOn: (s) => s.isCamOn,
  getIsVideoExpanded: (s) => s.isVideoExpanded,
  getLastActiveCallId: (s) => s.lastActiveCallId,
  getAddressForCall: (s) => (callId) => s.nominatimCache[callId] || '',
  getSosMode: (s) => s.mode,
  getSosFloatingPos: (s) => s.floatingPos,
  getSosFloatingSize: (s) => s.floatingSize,
}

const mutations = {
  PUSH_BANNER_QUEUE(s, callData) {
    if (!callData || !callData._id) return
    const exists = s.bannerQueue.some((b) => b._id === callData._id)
    if (exists) return
    s.bannerQueue.push(callData)
    if (s.bannerQueue.length > MAX_BANNERS) {
      s.bannerQueue.shift()
    }
  },
  POP_BANNER_QUEUE(s, callId) {
    const idx = s.bannerQueue.findIndex((b) => b._id === callId)
    if (idx >= 0) s.bannerQueue.splice(idx, 1)
  },
  CLEAR_BANNER_QUEUE(s) {
    s.bannerQueue = []
  },
  SET_OVERLAY_OPEN(s, bool) {
    s.overlayOpen = !!bool
  },
  SET_LAST_ACTIVE_CALL_ID(s, id) {
    s.lastActiveCallId = id || null
  },
  SET_MEETING(s, meeting) {
    s.currentMeeting = meeting || null
  },
  SET_VIDEO_STREAM(s, stream) {
    s.videoStream = stream || null
  },
  SET_AUDIO_STREAM(s, stream) {
    s.audioStream = stream || null
  },
  SET_MIC_ON(s, bool) {
    s.isMicOn = !!bool
  },
  SET_CAM_ON(s, bool) {
    s.isCamOn = !!bool
  },
  SET_VIDEO_EXPANDED(s, bool) {
    s.isVideoExpanded = !!bool
  },
  CACHE_NOMINATIM(s, { callId, address }) {
    if (!callId) return
    s.nominatimCache = { ...s.nominatimCache, [callId]: address || '' }
  },
  RESET_CALL_STATE(s) {
    s.currentMeeting = null
    s.videoStream = null
    s.audioStream = null
    s.isMicOn = false
    s.isCamOn = false
    s.isVideoExpanded = false
  },
  SET_SOS_MODE(s, mode) {
    s.mode = mode || 'docked'
  },
  SET_SOS_FLOATING_POS(s, pos) {
    s.floatingPos = { ...s.floatingPos, ...pos }
  },
  SET_SOS_FLOATING_SIZE(s, size) {
    s.floatingSize = { ...(s.floatingSize || {}), ...size }
  },
}

const actions = {
  // Intencionalmente vacío: toda la lógica imperativa vive en sos-call-service.js.
  // Los componentes disparan métodos del service (inyectado), no actions del store.
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
